export enum Department {
	None= 0,
	Secretariaat= 1,
	Sales= 2,
	TechnischeDienst= 3,
	DevWfShopOrOnline= 4,
	Programmatie= 5,
	Marketing= 6,
	Servicepakket = 7,
	Ticketsysteem = 8,
	Winfakt = 9,
	Overzetting = 10,
	Boekhoudportaal = 11
}

export function getDepartmentName(departmentId:Department):string {
	if (departmentId == Department.None) {
		return "Geen Afdeling";
	}
	if (departmentId == Department.Secretariaat) {
		return "Secretariaat";
	}
	if (departmentId == Department.Sales) {
		return "Sales";
	}
	if (departmentId == Department.TechnischeDienst) {
		return "Klantendienst";
	}
	if (departmentId == Department.DevWfShopOrOnline) {
		return "DEV Online";
	}
	if (departmentId == Department.Programmatie) {
		return "DEV WF Classic";
	}
	if (departmentId == Department.Marketing) {
		return "Marketing";
	}
	if (departmentId == Department.Servicepakket) {
		return "Servicepakket";
	}
	if (departmentId == Department.Ticketsysteem) {
		return "Ticketsysteem";
	}
	if (departmentId == Department.Winfakt) {
		return "Winfakt Online";
	}
	if (departmentId == Department.Overzetting) {
		return "Overzetting";
	}
	if (departmentId == Department.Boekhoudportaal) {
		return "Boekhoudportaal";
	}

	return "Geen gekozen";
}
